export default __webpack_public_path__ + "static/media/ciil_logo.5c1160b3.png";